(function () {
    'use strict';

    angular
        .module('ipmApp')
        .factory('PsychIntakeService', PsychIntakeService);

        PsychIntakeService.$inject = ['$http', '$q', 'DateUtils', 'DownloadBlobService', 'ShowUnexpectedErrorDialogService', '$rootScope', 'ClearLocalStorageService'];

    function PsychIntakeService ($http, $q, DateUtils, DownloadBlobService, ShowUnexpectedErrorDialogService, $rootScope, ClearLocalStorageService) {
        var baseURL = 'api/psych-intake';

    	var service = {
            'getPsychIntakeForm': getPsychIntakeForm,
            'viewWorkflow': viewWorkflow,
            'submitWorkflow': submitWorkflow,
            'getPsychIntakeFormsByPatientId': getPsychIntakeFormsByPatientId,
            'getTheMostRecentPsychIntakeFormOrById': getTheMostRecentPsychIntakeFormOrById,
            'savePsychIntakeForm': savePsychIntakeForm,
            'downloadPsychIntakeFormById': downloadPsychIntakeFormById,
            'downloadPsychIntakes': downloadPsychIntakes,
            'getAgreementByPsychIntakeFormId': getAgreementByPsychIntakeFormId,
            'getNotCompleteForm': getNotCompleteForm
        };

        function convertLocalDateFromServerForWorkflow(workflow) {
            if(workflow && workflow.answer) {
                if(workflow.answer.dateOfInjury) {
                    workflow.answer.dateOfInjury = DateUtils.convertLocalDateFromServer(workflow.answer.dateOfInjury);
                }
                if(workflow.answer.lastDayWorked) {
                    workflow.answer.lastDayWorked = DateUtils.convertLocalDateFromServer(workflow.answer.lastDayWorked);
                }
                if(workflow.answer.datePersonalInjury) {
                    workflow.answer.datePersonalInjury = DateUtils.convertLocalDateFromServer(workflow.answer.datePersonalInjury);
                }
                if (workflow.answer.diagnostics) {
                    for(var i = 0 ; i < workflow.answer.diagnostics.length; i++) {
                         workflow.answer.diagnostics[i].dateOfExam = DateUtils.convertLocalDateFromServer(workflow.answer.diagnostics[i].dateOfExam);
                    }
                }
            }
        }

        function getPsychIntakeForm(formId) {
            var url = baseURL;
            return $http.get(baseURL, { params: { formId: formId }}).then(function (resp) {
                return resp.data;
            });
        };

        function viewWorkflow(formId) {
            var url = baseURL + '/workflow';
            return $http.get(url, { params: { formId: formId }}).then(function (resp) {
                convertLocalDateFromServerForWorkflow(resp.data);
                return resp.data;
            });
        };

        function submitWorkflow(workflow) {
	        if(workflow && workflow.answer) {
	            if(workflow.answer.dateOfInjury) {
	                workflow.answer.dateOfInjury = DateUtils.convertLocalDateToServer(workflow.answer.dateOfInjury);
	            }
	            if(workflow.answer.datePersonalInjury) {
	                workflow.answer.datePersonalInjury = DateUtils.convertLocalDateToServer(workflow.answer.datePersonalInjury);
	            }
	            if(workflow.answer.lastDayWorked) {
	                workflow.answer.lastDayWorked = DateUtils.convertLocalDateToServer(workflow.answer.lastDayWorked);
	            }
	            if (workflow.answer.diagnostics) {
	                for(var i = 0 ; i < workflow.answer.diagnostics.length; i++) {
	                    workflow.answer.diagnostics[i].dateOfExam = DateUtils.convertLocalDateToServer(workflow.answer.diagnostics[i].dateOfExam);
	                }
	            }
            }
            var submitSection = workflow.section.template;
            return $http.post(baseURL + '/workflow/submit-' + submitSection , workflow).then(function (resp) {
                convertLocalDateFromServerForWorkflow(resp.data);
                return resp.data;
            }, function errorCallback(response) {
                ClearLocalStorageService.clearWorkflow();
                ShowUnexpectedErrorDialogService.open(response, 'savePsychIntakeForm', null)
                    .result.then(function (result) {
                    $rootScope.$emit('ipmApp.httpError', response);
                });
                return response;
            });
        }

        function getPsychIntakeFormsByPatientId(id, pageable) {
            var url = baseURL + '/patient';
            return $http.get(url, {
                params: {
                    patientId: id,
                    page: pageable.page,
                    size: pageable.size,
                    sort: pageable.sort
                }
            }).then(function (resp) {
                return resp.data;
            });
        }

        function savePsychIntakeForm(data) {
            var url = baseURL + '/create';
            return $http.post(url, data).then(function (resp) {
                return resp.data;
            });
        }
 
        function getTheMostRecentPsychIntakeFormOrById(psychIntakeFormId) {
            if (!psychIntakeFormId) {
                psychIntakeFormId = 0;
            }
            // if have psychIntakeFormId we will get by id, else we get by most recent
            var url = baseURL + '/most-recent' + '?psychIntakeFormId=' + psychIntakeFormId;
            return $http.get(url).then(function (resp) {
                return resp.data;
            });
        };

        function downloadPsychIntakeFormById(id) {
            var deferred = $q.defer();
            var url = baseURL + '/download/' + id;
            $http({
                url: url,
                method: "GET",
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                var contentType = headers('content-type');
                var blob = new Blob([data], {type: contentType});
                DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                deferred.resolve(true);
            }).error(function (data, status, headers, config) {
                deferred.resolve(false);
            });
            return deferred.promise;
        };

        function downloadPsychIntakes(fromDate, toDate) {
            var deferred = $q.defer();
            var url = baseURL + '/download-psych-intakes';
            $http({
                url: url,
                method: "GET",
                params: {fromDate: fromDate, toDate: toDate},
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'arraybuffer'
            }).success(function (data, status, headers, config) {
                if(status === 204) {
                    deferred.resolve(status);
                }else {
                    var contentType = headers('content-type');
                    var blob = new Blob([data], {type: contentType});
                    DownloadBlobService.download(blob, null, headers('Content-Disposition'));
                    deferred.resolve(true);
                }

            }).error(function (data, status, headers, config) {
                deferred.resolve(status);
            });
            return deferred.promise;
        }

        function getAgreementByPsychIntakeFormId() {
            var url = baseURL + '/agreement/get-agreement-workflow';
            return $http.get(url).then(function (resp) {
                convertLocalDateAgreementFromServer(resp.data);
                return resp;
            });
        };

        function getNotCompleteForm() {
            var url = baseURL + '/not-complete-form';
            return $http.get(url).then(function (resp) {
                return resp.data;
            });
        };

        function convertLocalDateAgreementFromServer(agreement) {
            if(agreement) {
                if (agreement.dateSigned) {
                    agreement.dateSigned = DateUtils.convertDateTimeFromServer(agreement.dateSigned);
                }
            }
        };
    	return service;
    };
})();
